import { render, staticRenderFns } from "./DownloadImg.vue?vue&type=template&id=68b7fe68&scoped=true&"
import script from "./DownloadImg.vue?vue&type=script&lang=js&"
export * from "./DownloadImg.vue?vue&type=script&lang=js&"
import style0 from "./DownloadImg.vue?vue&type=style&index=0&id=68b7fe68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7fe68",
  null
  
)

export default component.exports